import { defineType } from 'sanity';

export const qualityPillars = defineType({
    name: 'qualityPillars',
    title: 'Quality Pillars section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'pillars',
            title: 'Pillars',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'title',
                            title: 'Title',
                            type: 'localizedString',
                        },
                        {
                            name: 'description',
                            title: 'Description',
                            type: 'localizedString',
                        },
                    ],
                },
            ],
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Quality Pillars: ${title['en'] || title['sr']}`,
            };
        },
    },
});
